import PasswordDetails from './PasswordDetails';

export default PasswordDetails;
